<template>
  <div>
    <!-- Page Header Start -->
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="CheckinCampaignList" 
          :extra-items="[
            {
              text: checkinCampaignName.length > 13 ? checkinCampaignName.slice(0, 13) + '...' : checkinCampaignName,
              to: {
                name: 'CheckinCampaignView',
                params: {
                  id: checkinCampaignId
                }
              },
            },
            '簽到任務管理'
          ]" 
        />
      </div>
    </div>
    <!-- Page Header End -->

    <!-- Form Start -->
    <div class="email-wrapper wrapper">
      <div class="row bg-white">
        <div class="col-md-2 mail-sidebar pt-3">
          <div class="menu-bar">
            <ul class="menu-items">
              <li :class="{ active: step == '', disabled: !checkinCampaignId}" @click="goToStep('')">
                <a>簽到任務管理</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-10 main-view">
          <b-overlay :show="showLoading">
            <b-card>
              <!-- 簽到任務設定 section start -->
              <section v-if="step == ''">
                <NameBlock :label="'簽到活動名稱'" :name="checkinCampaignName" />
                <div class="row d-flex mb-12 mb-xl-12">
                  <div class="col-12 col-xl-12 mb-12 d-flex align-items-center">
                    <h4 class="font-weight-bold">
                      簽到任務管理
                    </h4>
                    <div v-if="isMissionSetting" class="ml-2" v-text="missionSettingText">
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-between mb-3" v-if="!isMissionSetting">
                  <!-- 新增簽到任務按鈕區 start -->
                  <b-button
                    class="flex-shrink-0 mr-2"
                    variant="inverse-primary"
                    @click="selectMissionSetting(standardMission)"
                    :disabled="showLoading"
                  ><i class="fa fa-plus"></i>新增簽到任務</b-button>
                  <!-- 新增簽到任務按鈕區 end -->
                </div>

                <!-- 編輯權益區塊 Start -->
                <CheckinMissionSetting 
                  ref="missionSetting" 
                  v-show="isMissionSetting" 
                  :selectedMission="selectedMission" 
                  :checkinCampaignId="checkinCampaignId"
                  @close="closeMissionSetting" 
                />
                <!-- 編輯權益區塊 End -->

                <!-- 簽到任務清單 Start -->
                <b-table 
                  v-show="missions.length > 0 && !isMissionSetting" 
                  striped hover responsive 
                  :items="missions" 
                  :fields="missionFields" 
                >
                  <template #cell(name)="data">
                      <div>{{ deepGet(data.item, 'name') }}</div>
                  </template>
                  <template #cell(period_type)="data">
                      <div>{{ deepGet(data.item, 'period_type') }}</div>
                  </template>
                  <template #cell(memo)="data">
                      <div>{{ deepGet(data.item, 'memo') }}</div>
                  </template>
                  <template #cell(actions)="data">
                    <b-button
                      class="mr-1"
                      variant="inverse-info"
                      @click="selectMissionSetting(data.item)"
                    >
                      <span class="mdi mdi-settings"></span> 編輯
                    </b-button>
                    <b-button
                      v-if="checkPermission([consts.CHECKIN_MISSION_DELETE])"
                      class="mr-1"
                      variant="inverse-danger"
                      @click="deleteMission(data.item)"
                    >
                      <span class="mdi mdi-delete"></span> 移除
                    </b-button>
                  </template>
                </b-table>
                <!-- 簽到任務清單 End -->
              </section>
              <!-- 簽到任務設定 section end -->
            </b-card>
          </b-overlay>
        </div>
      </div>
    </div>
    <!-- Form End -->

  </div>
</template>

<style>
.ckeditor-container {
  height: 400px; /* 自定義高度 */
}

.ckeditor-container .ck-editor__editable {
  min-height: 400px; /* 確保編輯區域的高度一致 */
}

.ck-editor__editable_inline {
  min-height: 200px;
  max-height: 400px; /* 如果需要限制高度 */
  height: 200px;
}
</style>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import benefitCardApi from "@/apis/benefitCard";
import mergeDefaultAndDataModel from "@/utils/mergeDefaultAndDataModel";
import deepGet from "lodash/get";
import {mapGetters} from "vuex";
import collectionApi from "@/apis/collection";
import * as consts from "@/consts";
import { merge } from "lodash";
import NameBlock from "@/pages/Dashboard/Share/NameBlock.vue";
import CheckinMissionSetting from "@/pages/Dashboard/CheckinMission/CheckinMissionSetting.vue";
import checkinCampaignApi from "@/apis/checkinCampaign";
import checkinMissionApi from "@/apis/checkinMission";
import PermissionChecker from "@/utils/PermissionChecker";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    NameBlock,
    CheckinMissionSetting,
    BreadCrumb
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      benefitCard: {
        title: { required },
        order: { required },
      }
    };
  },
  computed: {
    consts() {
      return consts
    },
    ...mapGetters("route", ["routeQuery"]),
  },
  data() {
    return {
      checkinCampaignId: '',
      checkinCampaignName: '',
      isMissionSetting: false,
      missionSettingText: '',
      showLoading: false,
      step: '',
      missions: [],
      missionFields: [
        { key: "name" , label: "名稱" },
        { key: "period_type" , label: "期間" },
        { key: "memo" , label: "任務內容" },
        { key: "actions", label: "管理" },
      ],
      standardMission: {
        checkin_campaign_id: '',
        name: null,
        period_type: "by_checkin_campaign",
        start_at: null,
        end_at: null,
        conditions: {
          type: "streak_type",
          streak_days: null,
          total_days: null,
          period_start_at: null,
          period_end_at: null,
        },
      },
      selectedMission: {},
      missionSettings: []
    }
  },
  async mounted() {
    this.checkinCampaignId = this.$route.params.campaign_id;
    console.log(this.checkinCampaignId);
    this.fetchCheckinCampaign();
    await this.fetchMissions();
  },
  methods: {
    async fetchCheckinCampaign() {
      try {
        this.isLoading = true;
        const { data } = await checkinCampaignApi.getCheckinCampaign(this.checkinCampaignId);
        this.checkinCampaignName = data.data.name;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },

    async fetchMissions() {
      this.showLoading = true;
      try {
        let response = await checkinMissionApi.getCheckinMissions({
          'checkin_campaign_id': this.checkinCampaignId
        });

        this.missions = response.data.data;
        this.showLoading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteMission(form) {
      try {
        this.showLoading = true;
        const result = await this.$swal({
          title: "你確定要刪除嗎？",
          html: `<br/>刪除 ${form.name}<br/><br/>刪除後，相關資料將無法回復，<br/>請您確認！<br/>`,
          type: "warning",
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonColor: "#3085D7",
          cancelButtonText: "不刪除",
          confirmButtonColor: "#DD3333",
          confirmButtonText: "確定刪除",
          reverseButtons: true,
        });

        if (!result.value) {
          return;
        }

        await checkinMissionApi.deleteCheckinMission(form.id);
        this.$swal({
            title: "刪除成功",
            type: "success",
            confirmButtonText: "確定",
        });
        await this.fetchMissions();
      } catch (error) {
        console.error(error);
        
        // 檢查是否為 403 錯誤且訊息包含 "This action is unauthorized"
        const errorTitle = (error.response?.status === 403 && 
            error.response?.data?.message?.includes("Only closed status can be deleted")) 
        ? "只能刪除已關閉的活動" 
        : "刪除失敗";
        
        this.$swal.fire({
          title: errorTitle,
          type: "error",
        });
      } finally {
        this.showLoading = false;
      }
    },


    deepGet,
    mergeDefaultAndDataModel,
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(date).replace(/\//g, '-');
    },
    async fetchCollections() {
      try {
        let response = await collectionApi.getCollections({
          with_items: 1,
          is_enabled: 1,
        });
        this.collectionOptions = response.data.data.map((collection) => {
          return {
            value: collection.id,
            text: collection.name + ' 共 ' + collection.items_count + ' 筆資料',
            items: collection.items,
            config: collection.config,
          };
        });
      } catch (error) {
        console.error(error);
      }
    },
    presentValidationErrors(validationKey) {
      return deepGet(this.v$, validationKey + '.$errors', []).map(error => error.$message).join(', ')
    },
    cancel() {
      this.$router.push({ name: 'BenefitCardList', query: this.routeQuery });
    },
    goToStep(step) {
      if (this.step == step) {
        return;
      }

      this.step = step
      if (location.hash !== this.step) {
        // NOTE: 這裡不使用 $router.replace，以避免 page rerender 導致 mounted 或其他 lifecycle hook 的內的 API 重複執行
        const newLocation = new URL(location.href)
        newLocation.hash = this.step
        window.history.replaceState('', '', newLocation.href);
      }
    },
    navigateToStepFromCurrentRoute() {
      const anchor = this.$route.hash;
      if (anchor) {
        this.goToStep(anchor);
      }
    },
    async submit(needValidate = true) {
      if (needValidate) {
        const result = await this.v$.$validate();
        if (!result) return false;
      }

      try {
        this.showLoading = true;
        // 編輯表單
        if (this.isEditing) {
          await benefitCardApi.updateBenefitCard(this.benefitCard.id, this.benefitCard);
          this.$swal("儲存成功", "", "success");
        }
        // 新增表單
        else {
          let response = await benefitCardApi.createBenefitCard({ ...this.benefitCard });
          this.benefitCard = merge({}, this.benefitCard, response.data.data);
          this.$swal("新增成功", "", "success");
          this.isEditing = true;
          this.$router.replace({ name: "BenefitCardEdit", params: { id: response.data.data.id } })
        }

        return true;
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "儲存失敗", "error");
        return false;
      } finally {
        this.showLoading = false;
      }
    },
    async fetchBenefitCard() {
      if (! this.benefitCard.id) {
        this.$swal("錯誤", "無法取得讀取 ID", "error");
        return;
      }

      try {
        this.showLoading = true;
        let response = await benefitCardApi.getBenefitCard(this.benefitCard.id);

        this.benefitCard = merge({}, this.benefitCard, response.data.data, {
          config: {
            data_source: this.benefitCard.config.data_source
          }
        });

        await this.fetchConfigs();
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取資料錯誤", "error");
        this.cancel();
      } finally {
        this.showLoading = false;
      }
    },
    async fetchConfigs() {
      try {
        const { data } = await benefitCardApi.getBenefitConfig(this.benefitCard.id, {});
        this.coupons = data.coupons;
        this.selectedCustomerLevels = data.customer_levels;

        this.missions = this.benefitCard.config.data_source.map((setting) => {
          return {
            ...setting,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getMaxOrder() {
      let response = await benefitCardApi.getMaxOrder();
      this.benefitCard.order = response.data.maxOrder+1;
      this.$set(this, 'benefitCard', this.benefitCard);
      this.showLoading = false;
    },
    async saveFields(fields) {
      try {
        this.showLoading = true;

        this.benefitCard.config.fields = fields;

        await benefitCardApi.updateBenefitCard(this.benefitCard.id, this.benefitCard);
        this.$swal("儲存成功", "", "success");
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "儲存資料錯誤", "error");
      } finally {
        this.showLoading = false;
      }
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },

    selectMissionSetting(missionSetting){
      console.log(missionSetting);
      this.isMissionSetting = true;

      // 新增的時候自動將order，設定為總數+1
      if (!missionSetting.id) {
        missionSetting.order = this.missionSettings.length +1;
      }

      //
      if (!missionSetting.id) {
        this.missionSettingText = "/ 新增簽到任務";
      } else {
        this.missionSettingText = "/ 編輯簽到任務";
      }

      this.selectedMission = { ...missionSetting }; // 使用淺拷貝避免直接修改原始資料

      this.$refs.missionSetting.initialize(this.selectedMission);
    },

    async deleteBenefitSetting(item) {
      const result = await this.$swal({
        title: "您確定要刪除嗎？",
        text: `權益名稱：${item.tab_name}`,
        type: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "不要刪除",
        confirmButtonText: "確定刪除",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        reverseButtons: true,
      })
      if (! result.value) {
        return
      }

      this.benefitCard.config = {
        ...this.benefitCard.config,
        data_source: this.benefitCard.config.data_source.filter(
          benefitSetting => benefitSetting.id !== item.id
        ),
      };

      this.missions = this.missions.filter(
        benefitSetting => benefitSetting.id !== item.id
      )

      console.log("132134");
      await this.submit(false);
    },
    closeMissionSetting() {
      this.isMissionSetting = false;
      this.fetchMissions();
      window.scrollTo({
        top: 0,
      });
    },
    handleSubmitCustomerLevel(customerLevels) {
      this.selectedCustomerLevels = customerLevels.map(customerLevel => ({
        ...customerLevel, // 保留原始的 coupon 屬性
      }));

      // 使用淺拷貝來更新 config
      this.benefitCard.config = {
        ...this.benefitCard.config,
        customer_levels: this.selectedCustomerLevels.map(customerLevel => ({
          hashid: customerLevel.id,
        })),
      };
    },
    deleteCustomerLevel(item) {
      this.benefitCard.config = {
        ...this.benefitCard.config,
        customer_levels: this.benefitCard.config.customer_levels.filter(
          customerLevel => customerLevel.hashid !== item.id
        ),
      };

      this.selectedCustomerLevels = this.selectedCustomerLevels.filter(
        customerLevel => customerLevel.id !== item.id
      )
    },
  }
}
</script>

<style lang="scss" scoped>
.menu-items > li {
  cursor: pointer;

  &.disabled {
    background-color: #ddd;
    opacity: 0.5;
    pointer-events: none;
  }

  &.has-checkbox {
    &:after {
      content: "\f134";
      font-family: "Material Design Icons";
      font-size: 16px;
    }
  }

  &.has-checkbox.has-checkbox--checked {
    &:after {
      content: "\f133";
      color: green;
    }
  }
}
</style>
